export default [{
  name: 'keyword',
  method: 'post',
  desc: '酒店关键字补全',
  path: '/obt/hotel/gj/shopping/keyword',
  params: {
    'cityId': '',
    'gngj': 0,
    'queryText': '',
    'mappingInterfacePlatId': ''
  }
},
{
  name: 'hotelList',
  method: 'post',
  desc: '酒店列表查询',
  path: '/obt/hotel/gj/shopping/hotelList',
  params: {
    'platZhid': 0,
    'corpId': '',
    'tripType': 0,
    'cityId': '',
    'checkInDate': '',
    'checkOutDate': '',
    'queryText': '',
    'facilities': '',
    'themeIds': '',
    'starRate': '',
    'brandId': '',
    'priceRange': '',
    'districtId': '',
    'districtName': '',
    'businessZoneId': '',
    'businessZoneName': '',
    'longitude': 0,
    'latitude': 0,
    'radius': 0,
    'sort': 12,
    'payType': '',
    'pageNum': 0,
    'count': 0
  }
},
{
  name: 'hotelInfo',
  method: 'post',
  desc: '酒店基础资料',
  path: '/obt/hotel/gj/shopping/hotelInfo',
  params: {
    'international': 0,
    'interfacePlatEnum': '',
    'jdid': ''
  }
},
{
  name: 'pricePlanList',
  method: 'post',
  desc: '酒店价格计划列表查询',
  path: '/obt/hotel/gj/shopping/pricePlanList',
  params: {
    'searchPlatZhid': 0,
    'searchLocal': 0,
    'corpId': '',
    'tripType': 1,
    'cityId': '',
    'interfacePlatId': '',
    'platHotelId': '',
    'checkInDate': '',
    'checkOutDate': '',
    'nationality': '',
    'adult': 0,
    'children': 0,
    'childrenAge': '',
    'roomCount': 0,
    'ratePlanId': ''
  }
},
{
  name: 'pricePlanOne',
  method: 'post',
  desc: '单个酒店价格计划查询',
  path: '/obt/hotel/gj/shopping/pricePlanOne',
  params: {
    'searchPlatZhid': 0,
    'searchLocal': 0,
    'corpId': '',
    'tripType': 1,
    'cityId': '',
    'interfacePlatId': '',
    'platHotelId': '',
    'checkInDate': '',
    'checkOutDate': '',
    'nationality': '',
    'adult': 0,
    'children': 0,
    'childrenAge': '',
    'roomCount': 0,
    'ratePlanId': ''
  }
},
{
  name: 'bookGj',
  method: 'post',
  desc: '国际酒店下单',
  path: '/obt/hotel/order/bookGj',
  params: {
    'platZhid': '', // 平台账号ID，该字段只针对OSS生效 ,
    'cityId': '', // 本地城市ID ,
    'interfacePlatId': '', // 接口供应商标识 ,
    'platHotelId': '', // 平台酒店ID ,
    'roomId': '', // 房型id,不能为空 ,
    'ratePlanId': '', // 价格计划id,不能为空 ,
    'checkInDate': '', // 入住日期：yyyy-mm-dd,不能为空 ,
    'checkOutDate': '', // 离店日期：yyyy-mm-dd,不能为空 ,
    'earliestArrivalTime': '', // 最早到店时间 ,
    'latestArrivalTime': '', // 最晚到店时间,不能为空 ,
    'noteToHotel': '', // 给酒店备注 ,
    'ydcrs': 0, // 预订时选择的成人数 ,
    'ydetAge': '', // 预订时选择的儿童年龄，同一间房多个儿童时，年龄半角逗号分隔 ,
    'ydets': 0, // 预订时选择的儿童数 ,
    'orderRooms': [ // 房间信息 ,
      {
        'roomNo': 0,
        'customers': [
          {
            'name': '',
            'customerType': 0,
            'childrenAge': 0,
            'email': '',
            'mobile': '',
            'phone': '',
            'gender': '',
            'nationality': '',
            'idCardNo': '',
            'empId': '',
            'empDeptId': '',
            'clbzj': 0,
            'fsEmpId': ''
          }
        ]
      }
    ],
    'linkman': '', // 联系人,不能为空 ,
    'linkMobile': '', // 联系手机,不能为空 ,
    'tripType': 1, // 差旅类型不能为空,1是因公,2是因私 ,
    'linkEmail': '', // 联系人邮箱 ,
    'travelInfo': {
      'projectId': '',
      'projectCode': '',
      'projectName': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'routeId': '',
      'costCenterId': '',
      'costCenterCode': '',
      'costCenterName': '',
      'violateitemCode': '',
      'violateitem': '',
      'reasonCode': '',
      'reasonDesc': '',
      'corpId': '',
      'corpCode': '',
      'corpName': '',
      'tripType': 0,
      'ccsqdRemark': '',
      'subjectCode': '',
      'ifSameOrder': ''
    },
    'orderFrom': '', // 订单来源,obt订单来源为10503 ,
    'sendMode': 0, // 配送类型0不需要行程单1公司统一配送2邮寄3机场自取 当选择一单一送时出现2和3选择 ,
    'recipient': '', // 收件人 ,
    'reciPhone': '', // 收件人电话 ,
    'reciEmail': '', // 收件人邮箱 ,
    'reciPostCode': '', // 邮政编码 ,
    'reciAddr': '', // 收件地址 ,
    'postCode': '', // 邮政编码 ,
    'psyqsj': '', // 配送要求时间 ,
    'postMothed': '', // 邮寄方式 ,
    'recommender': '', // 推荐人id ,
    'recommenderName': '', // 推荐人姓名 ,
    'corpBookerId': '' // 企业预订人id，后台代订是如果选择了需传入
  }
}]

